import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Container, Flashbar, FlashbarProps, Form, FormField, Input, Multiselect, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemUser, ItemUserGroup } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

export const SystemUsersAddPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const [idAirports, setIdAirports] = useState<number[]>([]);
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [userName, setUserName] = useState<string>("");
    const [user, setUser] = useState<ItemUser>({} as ItemUser);
    const [usersGroups, setUsersGroups] = useState<ItemUserGroup[]>({} as ItemUserGroup[]);
    const [isValidUserName, setIsValidUserName] = useState<boolean>(false);
    const { navigate } = useRouter();
    const { menu } = useGlobalState();
    useEffect(() => {

    }, []);
    const handleAssignUserAirport = async (userName: string) => { // Make the function async
        try {
            setLoading(true)
            console.log("handleAssignUserAirport", userName)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/assign.airport',
                },
                body: JSON.stringify({ userName: userName }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, 'success', setData);
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }

        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    }
    const handleUpdateUser = async () => { // Make the function async
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/update',
                },
                body: JSON.stringify(user),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, 'success', setData);

                setUser({} as ItemUser);
                setIsValidUserName(false);
                setUserName("");
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }

        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    }

    const handleCheckUserName = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/users/check',
                },
                body: JSON.stringify({
                    userName: userName
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                setIsValidUserName(true);
                if (dataWeb.usersGroups) {
                    setUser({
                        ...user,
                        userName: userName,
                        idUser: 0,
                    });
                    setUsersGroups(dataWeb.usersGroups.map((ug: ItemUserGroup) => ({
                        ...ug,
                        label: ug.groupName,
                        value: ug.idGroup.toString()
                    })));

                }
            } else {
                if (dataWeb.code == -2) {
                    setMessages([
                        {
                            type: 'warning',
                            content: dataWeb.status,
                            id: 'delete-error',
                            dismissible: true,
                            buttonText: 'Asignar',
                            onButtonClick: () => {
                                handleAssignUserAirport(userName)
                            },
                            onDismiss: () => setMessages([]),
                        },
                    ]);
                } else {
                    addNotification(dataWeb.status, 'error', setData);
                }
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            console.log("END")
            setLoading(false)
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Crear usuario</Header>
                    <Flashbar items={messages} />
                    <Container>
                        <SpaceBetween size="m" direction='vertical'>
                            <SpaceBetween size="m" direction='horizontal'>
                                <FormField label="Nombre de usuario">
                                    <Input
                                        placeholder="Ingrese el nombre de usuario"
                                        value={userName}
                                        disabled={isValidUserName}
                                        onChange={event => setUserName(event.detail.value)}
                                        onKeyUp={event => {
                                            if (event.detail.key === 'Enter' && userName.length >= 3) {
                                                handleCheckUserName();
                                            }
                                            setMessages([])
                                        }}
                                    />
                                </FormField>
                                <FormField label="&nbsp;">
                                    <Button variant="primary" disabled={isValidUserName || userName.length < 3} onClick={(e) => handleCheckUserName()}>Siguiente</Button>
                                </FormField>


                            </SpaceBetween>
                            {isValidUserName && (
                                <>
                                    <div>El nombre de usuario '{userName}' está disponible.</div>
                                    <Form actions={
                                        <SpaceBetween size="m" direction='horizontal'>
                                            <Button variant="link" onClick={() => {
                                                setUser({} as ItemUser);
                                                setIsValidUserName(false);
                                            }}>Cancelar</Button>
                                            <Button variant="primary" onClick={() => {
                                                handleUpdateUser()
                                            }}>Crear usuario</Button>
                                        </SpaceBetween>
                                    }>
                                        <SpaceBetween size="m" direction='vertical'>
                                            <FormField label="Nombre del usuario">
                                                <Input
                                                    disableBrowserAutocorrect
                                                    autoComplete="off"
                                                    placeholder="Ej: Juan Pérez"
                                                    value={user.name || ""}
                                                    onChange={event => setUser({ ...user, name: event.detail.value })}

                                                />
                                            </FormField>

                                            <SpaceBetween size="m" direction='horizontal'>
                                                <FormField label="Email del usuario">
                                                    <Input
                                                        autoComplete="off"
                                                        placeholder="Ej: juan.perez@example.com"
                                                        value={user.userEmail || ""}
                                                        onChange={event => setUser({ ...user, userEmail: event.detail.value })}
                                                    />
                                                </FormField>
                                                <FormField label="Grupos asociados">
                                                    <Multiselect
                                                        selectedOptions={usersGroups.filter((group: { value: any; }) =>
                                                            user.jsonGroups?.includes(Number(group.value))
                                                        )}
                                                        options={usersGroups.map((group: { idGroup: number; groupName: string; }) => ({
                                                            label: group.groupName,
                                                            value: group.idGroup.toString()
                                                        }))}

                                                        onChange={event => {
                                                            // 2. Map the selected objects back to an array of numbers for your state
                                                            const selectedIds = event.detail.selectedOptions.map(item => Number(item.value));
                                                            setUser({ ...user, jsonGroups: selectedIds });
                                                        }}

                                                        placeholder="Seleccione los grupos de usuario"
                                                    />
                                                </FormField>

                                            </SpaceBetween>
                                        </SpaceBetween>
                                    </Form>
                                </>
                            )}
                        </SpaceBetween>

                    </Container>

                </SpaceBetween>
            }
        />
    )
};
